import { Component } from 'react';
import { StaticValues } from '../../../../../../../../insfrastructure/services/static_values';
import { CPFValidator, emptyField, ErrorMessage, errorsLength, formatErrors, validateEmail, validatePasswordConfirmation } from '../../../../../../../../insfrastructure/utils/form-validators';
import { Input } from '../../../../../../../components/input';
import { Select } from '../../../../../../../components/select';
import { DateOfBirthField } from '../../../../../../../components/date-of-birth-field';
import documentIcon from '../../../../../../../../assets/icons/document.png';
import emailIcon from '../../../../../../../../assets/icons/email.png';
import fullPersonIcon from '../../../../../../../../assets/icons/full_person.png';
import passwordIcon from '../../../../../../../../assets/icons/password.png';
import profileIcon from '../../../../../../../../assets/icons/profile.png';
import './styles.sass';
import { PasswordRequirements } from '../../../../../../../components/password-requirements';

export class CompanyUserData extends Component<{form_data: Record<string, any>, onSubmit: (form: Record<string, any>) => void, onBack?: () => void}> {

  state: any = {
    form: this.props.form_data,
    formErrors: {},
    genderOptions: [],
    showPassword: false
  }

  componentDidMount() {
    this.getStaticValues();
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        
        if (!staticValues || !staticValues.gender) {
          console.error('Static values ou gender não encontrado');
          return;
        }
          
        const genderOptions = Object.keys(staticValues.gender)
          .map((key: any) => ({ value: key, label: staticValues.gender[key] }))
          .sort((a, b) => a.label.localeCompare(b.label));
        
        this.setState({ genderOptions });
      }, 1000);
    } catch (error) {
      console.error('Erro ao carregar valores estáticos:', error);
    }
  }

  onSubmit = () => {
    const errors = formatErrors({
      full_name: [emptyField(this.state.form.full_name, 'string')],
      date_of_birth: [emptyField(this.state.form.date_of_birth, 'string')],
      cpf: [emptyField(this.state.form.cpf, 'string'), CPFValidator(this.state.form.cpf)],
      manager_email: [validateEmail(this.state.form.manager_email)],
      gender: [emptyField(this.state.form.gender, 'string')],
      password: [emptyField(this.state.form.password, 'string')],
      password_confirmation: [emptyField(this.state.form.password_confirmation, 'string'), validatePasswordConfirmation(this.state.form.password, this.state.form.password_confirmation)]
    });

    this.setState({ formErrors: errors });

    if(errorsLength(errors) > 0 || !this.state.isPasswordValidated) return;

    try {
        setTimeout(() => {
            this.setState({ sended: true });
            this.props.onSubmit(this.state.form);
        });
    } catch (error) {}
  }

  render() {
    return (
      <div className='form company-user'>
        <div className='form-container'>
          <div className='text'>
            <h4>Toda empresa precisa ter um perfil responsável por atualizá-la.</h4>
            <p>Este perfil administrador poderá deletar e conceder acesso de admin. para outros usuários que entrarem no nome da sua empresa e poderá editar o perfil da empresa.</p>
          </div>
          <div className='columns'>
            <div className='column'>
              <div className='field-group'>
                <Input
                name='full_name'
                label='Nome Completo'
                icon={profileIcon}
                required={true}
                value={this.state.form.full_name}
                onChange={e => this.setState({ form: { ...this.state.form, full_name: e } })}/>
                <ErrorMessage errors={this.state.formErrors['full_name']} />
              </div>
              <div className='field-group'>
                <Input
                name='manager_email'
                label='E-Mail'
                icon={emailIcon}
                required={true}
                value={this.state.form.manager_email}
                onChange={e => this.setState({ form: { ...this.state.form, manager_email: e } })}/>
                <ErrorMessage errors={this.state.formErrors['manager_email']} />
              </div>
              <div className='field-group'>
                <Input
                name='cpf'
                label='CPF'
                icon={documentIcon}
                mask='999.999.999-99'
                required={true}
                value={this.state.form.cpf}
                onChange={e => this.setState({ form: { ...this.state.form, cpf: e } })}/>
                <ErrorMessage errors={this.state.formErrors['cpf']} />
              </div>
              <div className='field-group'>
                <DateOfBirthField
                name='date_of_birth'
                label='Data de Nascimento'
                required={true}
                value={this.state.form.date_of_birth}
                onChange={e => this.setState({ form: { ...this.state.form, date_of_birth: e } })}
                errors={this.state.formErrors['date_of_birth']} />
              </div>
              <div className='field-group'>
                <Select
                name='gender'
                label='Gênero'
                icon={fullPersonIcon}
                required={true}
                options={this.state.genderOptions}
                value={this.state.form.gender}
                onChange={e => this.setState({ form: { ...this.state.form, gender: e } })}/>
                <ErrorMessage errors={this.state.formErrors['gender']} />
              </div>
            </div>
            <div className='column'>
              <div className='field-group'>
                <Input
                name='password'
                label='Senha'
                type='password'
                icon={passwordIcon}
                required={true}
                value={this.state.form.password}
                onChange={e => this.setState({ form: { ...this.state.form, password: e } })}/>
                <ErrorMessage errors={this.state.formErrors['password']} />
              </div>
              <div className='field-group'>
                <Input
                name='password_confirmation'
                label='Confirmar Senha'
                type='password'
                icon={passwordIcon}
                required={true}
                value={this.state.form.password_confirmation}
                onChange={e => this.setState({ form: { ...this.state.form, password_confirmation: e } })}/>
                <ErrorMessage errors={this.state.formErrors['password_confirmation']} />
              </div>
              <PasswordRequirements
              password={this.state.form.password}
              email={this.state.form.manager_email}
              isPasswordValidated={isPasswordValidated => this.setState({ isPasswordValidated })}/>
            </div>
        </div>
        <div className='submit-block'>
          <div>
            <p>
              Não se preocupe, suas informações estão seguras conosco. Seu CPF será usado para assegurar seu cadastro único e seus dados não serão compartilhado com os candidatos.
            </p>
          </div>
          <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
            <div className='columns' style={{ borderBottom: 'none', borderTop: 'none', width: '100%', alignItems: 'center' }}>
              {this.props.onBack ? (
                <>
                  <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                    <button className='secondary submit' onClick={this.props.onBack} style={{ width: '100%', margin: 0, border: '1px solid #105099' }}>Voltar</button>
                  </div>
                  <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                    <button className='primary submit' onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>Continuar</button>
                  </div>
                </>
              ) : (
                <div className='column' style={{ borderRight: 'none', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                  <button className='primary submit' onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>Continuar</button>
                </div>
              )}
            </div>
          </div>
        </div>
        </div>
      </div>
    )
  }
}